"use client";

import { SelectField, TextField } from "@/components/tool-kit/primitives";
import { BUTTON_SMALL, CARD } from "@/components/tool-kit/styles";

/*
 * The study schedule generator's exam list: one card per subject with its name, exam
 * date and difficulty. Every word comes in through `labels`, which the widget passes
 * its strings as.
 */

export type Difficulty = "1" | "2" | "3";

export interface SubjectRow {
  id: string;
  name: string;
  exam: string;
  difficulty: Difficulty;
}

export interface SubjectRowLabels {
  subjectLabel: string;
  subjectPlaceholder: string;
  examDateLabel: string;
  difficultyLabel: string;
  difficulty: Readonly<Record<Difficulty, string>>;
  removeSubject: string;
}

const LEVELS: readonly Difficulty[] = ["1", "2", "3"];

export function SubjectRows({
  rows,
  labels,
  onChange,
  onRemove,
}: {
  rows: readonly SubjectRow[];
  labels: SubjectRowLabels;
  onChange: (id: string, patch: Partial<SubjectRow>) => void;
  onRemove: (id: string) => void;
}) {
  return (
    <ul className="space-y-3">
      {rows.map((row) => (
        <li
          className={`${CARD} grid gap-3 sm:grid-cols-[1fr_11rem_8rem_auto] sm:items-end`}
          key={row.id}
        >
          <TextField
            id={`ss-name-${row.id}`}
            label={labels.subjectLabel}
            onChange={(name) => onChange(row.id, { name })}
            placeholder={labels.subjectPlaceholder}
            value={row.name}
          />
          <TextField
            id={`ss-exam-${row.id}`}
            label={labels.examDateLabel}
            onChange={(exam) => onChange(row.id, { exam })}
            type="date"
            value={row.exam}
          />
          <SelectField<Difficulty>
            id={`ss-diff-${row.id}`}
            label={labels.difficultyLabel}
            onChange={(difficulty) => onChange(row.id, { difficulty })}
            options={LEVELS.map((value) => ({
              value,
              label: labels.difficulty[value],
            }))}
            value={row.difficulty}
          />
          <button
            className={BUTTON_SMALL}
            disabled={rows.length === 1}
            onClick={() => onRemove(row.id)}
            type="button"
          >
            {labels.removeSubject}
          </button>
        </li>
      ))}
    </ul>
  );
}
